import { BrowserError } from '@/components/BrowserError/BrowserError';
import { useConfig } from '@/hooks/useConfig/useConfig';
import { useAirKeyTracePageView } from '@/utils/airKeyTrace';

// TODO: Add analytics for 'Copy Link' button
export const PrivateBrowserError = ({
  link,
  iOS,
}: {
  link: string;
  iOS?: boolean;
}) => {
  const { content, locale } = useConfig();
  useAirKeyTracePageView('private_browser_not_supported');
  return (
    <BrowserError
      title={content.privateBrowserNotSupported.title[locale]}
      body={content.privateBrowserNotSupported.description[locale].replace(
        /Safari/g,
        iOS ? 'Safari' : 'Chrome',
      )}
      link={link}
    />
  );
};
